import { Identifiable, Planzone, CalendarHolidays } from "@planzone/dto";
import { Linker } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";

function assignDefaultCalendarHolidaysToPlanzone(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    calendarHolidays: Identifiable<CalendarHolidays>,
  ) =>
    new Promise<Identifiable<Planzone>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<Planzone>>({
          endpoint: `/planzones/${planzone.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            defaultCalendarHolidays: `calendarHolidayses/${calendarHolidays.uuid}`,
          },
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { assignDefaultCalendarHolidaysToPlanzone };
